import { ReactNode } from 'react'

import {
    deleteNegativeKeyword,
    deleteCampaignNegativeKeyword,
} from 'api/Cerebro/orgScoped/amazonAdsApi'
import { DeleteNegativeKeywordField } from 'components/EditableFields/NegativeKeywordFields'
import { UNDEFINED_VALUE } from 'const/formatting'
import { isUnset } from 'helpers/utilities'
import { NegativeKeyword, CellRenderProps } from 'types'

export function negativeKeywordIdRenderer<RecordType extends NegativeKeyword>({
    record,
    undefinedValue = UNDEFINED_VALUE,
}: CellRenderProps<RecordType>): ReactNode {
    return record.text ?? undefinedValue
}

export function archiveCampaignNegativeKeywordRenderer<
    RecordType extends NegativeKeyword,
>({
    record,
    readonly,
    reloadData,
    undefinedValue = UNDEFINED_VALUE,
}: CellRenderProps<RecordType>): ReactNode {
    return isUnset(record.id) ? (
        undefinedValue
    ) : (
        <DeleteNegativeKeywordField
            apiFunc={(keywordId) => deleteCampaignNegativeKeyword(keywordId)}
            readOnly={readonly}
            record={record}
            reloadData={reloadData}
        />
    )
}

export function archiveAdGroupNegativeKeywordRenderer<
    RecordType extends NegativeKeyword,
>({
    record,
    readonly,
    reloadData,
    undefinedValue = UNDEFINED_VALUE,
}: CellRenderProps<RecordType>): ReactNode {
    return isUnset(record.id) ? (
        undefinedValue
    ) : (
        <DeleteNegativeKeywordField
            apiFunc={(keywordId) => deleteNegativeKeyword(keywordId)}
            readOnly={readonly}
            record={record}
            reloadData={reloadData}
        />
    )
}
